/*
 * Confidential and Proprietary.
 * Do not distribute without Bloom Harbor Gifts consent.
 * Copyright Bloom Harbor Gifts 2019. All rights reserved.
 */
import React from 'react';
import ChevronRightRoundedIcon from '@material-ui/icons/ChevronRightRounded';
import ChevronLeftRoundedIcon from '@material-ui/icons/ChevronLeftRounded';
import { makeStyles } from '@material-ui/core';
import {
    oneOfType, func, shape, any, string,
} from 'prop-types';

const useStyles = makeStyles({
    circle: {
        position: 'absolute',
        backgroundColor: '#FFFFFF',
        borderRadius: '50%',
        width: '40px',
        height: '40px',
        border: '1px solid #E6DDF4',
        textAlign: 'center',
        top: '50%',
        transform: 'translateY(-50%)',
        zIndex: '1030',
        cursor: 'pointer',
        '&.right-circle': {
            right: '1rem',
        },
        '&.left-circle': {
            left: '1rem',
        },
    },
});

function SliderArrow({ sliderRef, direction }) {
    const classes = useStyles();

    const handleNextClick = () => {
        if (!sliderRef?.current) return;
        sliderRef.current.slickNext();
    };

    const handlePrevClick = () => {
        if (!sliderRef?.current) return;
        sliderRef.current.slickPrev();
    };

    return (
        <>
            {(direction === 'left') && (
                <button type="button" className={`${classes.circle} left-circle`}>
                    <ChevronLeftRoundedIcon onClick={handlePrevClick} />
                </button>
            )}
            {(direction === 'right') && (
                <button type="button" className={`${classes.circle} right-circle`}>
                    <ChevronRightRoundedIcon onClick={handleNextClick} />
                </button>
            )}

        </>

    );
}

SliderArrow.propTypes = {
    sliderRef: oneOfType([
        func,
        shape({ current: any }),
    ]).isRequired,
    direction: string.isRequired,
};

export default SliderArrow;
